import { MarkSpec } from 'prosemirror-model';

/**
 * This is used to preserve <font> tags which are omitted normally when
 * ngx-editor ingests content
 */
export const fontMark: MarkSpec = {
  attrs: {
    color: { default: null },
    face: { default: null },
    size: { default: null },
  },
  // When typing, include the text of the input into the tag
  inclusive: true,
  parseDOM: [
    {
      tag: 'font',
      getAttrs (dom: HTMLElement) {
        return {
          color: dom.getAttribute('color'),
          face: dom.getAttribute('face'),
          size: dom.getAttribute('size'),
        };
      },
    },
  ],
  toDOM (mark) {
    const attrs: Record<string, string> = {};
    if (mark.attrs.color) attrs.color = mark.attrs.color;
    if (mark.attrs.face) attrs.face = mark.attrs.face;
    if (mark.attrs.size) attrs.size = mark.attrs.size;
    return ['font', attrs, 0];
  },
};
